module.exports = __webpack_public_path__ + "static/media/image_2x2.e9361154.png";